const prefix = '/store';

const common = {
  enumModel: '/common/enum/structure',
  shopCategories: '/common/store/categories',
  shopTypes: '/common/store/type',
  shopLocation: '/common/store/location',
  productCategories: '/common/product/categories',
  userList: '/common/list/user',
  storeAccounts: (no) => `/common/store/${no}/account`
};
const bizTransaction = {
  getList: prefix + '/bizLog',
  detail: (no) => `${prefix}/bizLog/${no}`
};
const bizRequest = {
  getList: `${prefix}/request`,
  detail: (no) => `${prefix}/request/${no}`,
  save: `${prefix}/request/save`
};
const coupon = {
  getList: `${prefix}/coupon`,
  detail: (no) => `${prefix}/coupon/${no}`,
  save: `${prefix}/coupon/save`,
  remove: (no) => `${prefix}/coupon/${no}`,
  issue: `${prefix}/coupon/issue`,
  histories: `${prefix}/coupon/histories`
};
const dashboard = {
  classify: `${prefix}/dashboard/classify`,
  transaction: `${prefix}/dashboard/transaction`,
  sales: `${prefix}/dashboard/sales`,
  count: `${prefix}/dashboard/count`
};
const favProduct = {
  getList: '/store/favorite/product'
};
const favStore = {
  getList: '/store/favorite/store'
};
const review = {
  getList: `${prefix}/review`,
  saveRepl: `${prefix}/review/save`
};
const cs = {
  getList: `${prefix}/customer`,
  detail: (storeNo, userNo) => `${prefix}/customer/${storeNo}/${userNo}`,
  save: `${prefix}/customer/save`
};
const order = {
  getList: `${prefix}/order`,
  detail: (no) => `${prefix}/order/${no}`,
  state: `${prefix}/order/status`,
  partialRefund: `${prefix}/order/partial-refund`,
  memo: `${prefix}/order/memo`
};
const product = {
  getList: `${prefix}/product`,
  detail: (no) => `${prefix}/product/${no}`,
  save: `${prefix}/product/save`,
  remove: (no) => `${prefix}/product/${no}`,
  setSoldOut: `${prefix}/product/set/sold-out`,
  setForSale: `${prefix}/product/set/for-sale`,
  hide: `${prefix}/product/hide`,
  show: `${prefix}/product/show`,
  saveBulk: `${prefix}/product/save/bulk`,

  save_order: `${prefix}/product/sort`
};
const productCategory = {
  getList: `${prefix}/product/category`,
  detail: (productCategoryNo) => `${prefix}/product/category/${productCategoryNo}`,
  save: `${prefix}/product/category`,
  update: `${prefix}/product/category/update`,
  remove: (productCategoryNo) => `${prefix}/product/category/${productCategoryNo}`,

  orders: (storeNo) => `${prefix}/product/category/orders/${storeNo}`,
  save_order: `${prefix}/product/category/sort`
};
const recent = {
  getList: `${prefix}/recent`
};
const store = {
  getList: `${prefix}/shop`,
  detail: (no) => `${prefix}/shop/${no}`,
  saveBasic: `${prefix}/shop/save/basic`,
  saveBusiness: `${prefix}/shop/save/business`,
  savePayment: `${prefix}/shop/save/payment`,
  saveImages: `${prefix}/shop/save/images`,
  saveNotice: `${prefix}/shop/save/notice`,
  saveDelivery: `${prefix}/shop/save/delivery`,
  serviceableArea: (no) => `${prefix}/shop/${no}/area`
};
const pos = {
  connection: (storeNo) => `${prefix}/pos/${storeNo}/connection`,
  connectionOptions: (storeNo) => `${prefix}/pos/${storeNo}/connection/options`,
  sync: (storeNo) => `${prefix}/pos/${storeNo}/sync`,
  syncRuns: (storeNo) => `${prefix}/pos/${storeNo}/sync-runs`,
  syncRun: (storeNo, syncRunNo) => `${prefix}/pos/${storeNo}/sync-runs/${syncRunNo}`,
  issues: (storeNo) => `${prefix}/pos/${storeNo}/issues`
};
const admin = {
  login: prefix + '/login',
  pwd: prefix + '/password/change',
  logout: prefix + '/logout'
};
const chat = {
  create: `/v1/chat/create`,
  getList: `/v1/chat/rooms`,
  detail: `/v1/chat/room`,
  chats: (no) => `/v1/chat/${no}/chats`,
  saveFile: `/v1/chat/file`,
  bubbleCount: (no) => `/v1/chat/bubble/${no}`,
  read: (roomNo, userNo) => `/v1/chat/read/${roomNo}/${userNo}`,
  emitter: (userNo) => `/v1/emitter/${userNo}`
};

export {
  common,
  bizTransaction,
  bizRequest,
  coupon,
  dashboard,
  favProduct,
  favStore,
  review,
  cs,
  order,
  product,
  productCategory,
  recent,
  store,
  pos,
  admin,
  chat
};
